/**
 * 和ARMS相关的功能
 */

'use strict';

// 最小值不能小于 0

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MIN_VALUE = 0;
// 最大值不能超过 30S
var MAX_VALUE = 30 * 1000;

function validate(value) {
    // 校验非法值
    if (typeof value != 'number' || value > MAX_VALUE || value < MIN_VALUE) {
        return 0;
    } else {
        return Math.round(value);
    }
}

// 获取自定义时间的值
function getTimeInterval(endTime) {
    var interval = window.performance && window.performance.timing ? endTime - window.performance.timing.fetchStart : 0;
    return validate(interval);
}

// 自定义可交互时间
function calculateFirstInteractive() {
    return new Promise(function (resolve) {
        arms.interactiveTimerId = setTimeout(function () {
            resolve(getTimeInterval(Date.now()));
        }, 0);
    }).catch(function (e) {
        throw new Error(e);
    });
}

// 自定义白屏时间
function getWhitePaint() {
    var firstPaint = 0;
    return new Promise(function (resolve) {
        if (typeof window.performance.getEntriesByType === 'function') {
            var performanceEntries = performance.getEntriesByType('paint');
            if (performanceEntries) {
                for (var i = 0, len = performanceEntries.length; i < len; i++) {
                    var item = performanceEntries[i];
                    if (item.name === 'first-paint') {
                        firstPaint = item.startTime;
                    }
                }
            }
        } else {
            // Chrome
            // eslint-disable-next-line no-lonely-if
            if (window.chrome && window.chrome.loadTimes) {
                // Convert to ms
                var loadTime = window.chrome.loadTimes();
                firstPaint = (loadTime.firstPaintTime - loadTime.startLoadTime) * 1000;
            } else if (typeof window.performance.timing.msFirstPaint === 'number') {
                firstPaint = window.performance.timing.msFirstPaint - window.performance.timing.navigationStart;
            }
        }
        // 上报之前过滤非法值
        resolve(validate(firstPaint));
    }).catch(function (e) {
        throw new Error(e);
    });
}

// ARMS 相关个的自定义方法
var arms = {
    // 自定义错误上报
    error: function error(_error, pos) {
        if (window.__bl && window.__bl.error) {
            window.__bl.error(_error, pos);
        } else if (window.__bl) {
            window.__bl.pipe = window.__bl.pipe || [];
            window.__bl.pipe.push(['error', _error, pos]);
        }
    },

    // 自定义接口上报
    api: {
        // 成功的上报
        success: function success(url, time, code, msg) {
            if (window.__bl && window.__bl.api) {
                window.__bl.api(url, true, time, code, msg);
            } else if (window.__bl) {
                window.__bl.pipe = window.__bl.pipe || [];
                window.__bl.pipe.push(['api', url, true, time, code, msg]);
            }
        },

        // 错误的上报
        error: function error(url, time, code, msg) {
            if (window.__bl && window.__bl.api) {
                window.__bl.api(url, false, time, code, msg);
            } else if (window.__bl) {
                window.__bl.pipe = window.__bl.pipe || [];
                window.__bl.pipe.push(['api', url, false, time, code, msg]);
            }
        }
    },
    // 自定义性能指标上报
    report: function report(promisesObj) {
        try {
            // 空对象
            if (!promisesObj) {
                return;
            }

            // 不支持promise
            if (!('Promise' in window)) {
                return;
            }

            // 如果不支持采集
            if (!window.performance) {
                return;
            }

            // 校验传入的参数的类型，必须是 promise
            Object.keys(promisesObj).forEach(function (index) {
                var promiseItem = promisesObj[index];

                if (typeof promiseItem == 'number') {
                    // 校验一下合法性
                    promisesObj[index] = validate(promiseItem);
                    return;
                }

                if (!promiseItem || !promiseItem.then) {
                    throw new Error('performance package: first argument of function reportPerformance need to be a promise or thenable!');
                }
                // 对时间戳进行处理
                promisesObj[index] = promiseItem.then(function (value) {
                    return getTimeInterval(value);
                });
            });

            var defaultPro = {
                // 自定义可交互
                ctti: calculateFirstInteractive(),
                // 白屏时间
                t1: getWhitePaint()
            };

            // 用传入的promise覆盖掉默认的采集方式
            var promiseTemp = Object.assign(defaultPro, promisesObj);

            // 将对象变成可遍历的数组
            var promiseKeys = [];
            var promiseValues = [];
            Object.keys(promiseTemp).forEach(function (key) {
                promiseKeys.push(key);
                promiseValues.push(promiseTemp[key]);
            });

            // 等待所有的 promise 都执行完成
            Promise.all(promiseValues).then(function (data) {
                var timing = {};
                data.forEach(function (value, index) {
                    timing[promiseKeys[index]] = value;
                });

                // 上报所有的数据
                var performance = ['performance', timing];
                if (window.__bl && window.__bl.performance) {
                    window.__bl.performance(timing);
                } else if (window.__bl) {
                    window.__bl.pipe = window.__bl.pipe || [];
                    window.__bl.pipe.push(performance);
                }
            }).catch(function (e) {
                console.error(e);
                throw new Error(e);
            });
        } catch (e) {
            throw new Error(e);
        }
    },


    // 垃圾回收
    gc: function gc() {
        clearTimeout(this.interactiveTimerId);
    }
};

exports.default = arms;